const FilterWizardStates = {
  Active: "ACTIVE",
  Completed: "COMPLETED",
  Exited: "EXITED"
};
var FilterWizardEventType = /* @__PURE__ */ ((FilterWizardEventType2) => {
  FilterWizardEventType2["Init"] = "xstate.init";
  FilterWizardEventType2["Back"] = "Back";
  FilterWizardEventType2["Complete"] = "Complete";
  FilterWizardEventType2["Enter"] = "Enter";
  FilterWizardEventType2["Exit"] = "Exit";
  FilterWizardEventType2["Next"] = "Next";
  FilterWizardEventType2["Reset"] = "Reset";
  return FilterWizardEventType2;
})(FilterWizardEventType || {});
export {
  FilterWizardEventType,
  FilterWizardStates
};
